var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 4.31284C11.04 6.08136 9.53304 7.51958 7.68 7.51958H3.31896L4.27896 6.60337L3.6 5.95538L1.48104 7.97769L3.6 10L4.27896 9.35201L3.31896 8.4358H7.68C10.062 8.4358 12 6.58619 12 4.31284H11.04ZM4.32 2.48042H8.68104L7.72104 3.39663L8.4 4.04462L10.519 2.02231L8.4 0L7.72104 0.647991L8.68104 1.5642H4.32C1.938 1.5642 0 3.41381 0 5.68716H0.96C0.96 3.91887 2.4672 2.48042 4.32 2.48042Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionRed);
export default __webpack_public_path__ + "static/media/transaction-red.9365a02c34589f25b2bc1c209792767e.svg";
export { ForwardRef as ReactComponent };